// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.bs.jsx";
import * as Toast from "./components/Toast/Toast.bs.jsx";
import * as React from "react";
import * as Styles from "./styles/components/Styles.bs.jsx";
import * as LogUtils from "./utils/LogUtils.bs.jsx";
import * as Reactfire from "./backend/Reactfire.bs.jsx";
import * as Reactfire$1 from "reactfire";
import * as AppStorage from "./utils/AppStorage.bs.jsx";
import * as ReactIntl from "react-intl";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as PolyfillsJs from "./polyfills.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as VirtualpwaRegister from "virtual:pwa-register";

function polyfill(prim) {
  PolyfillsJs.polyfill();
}

PolyfillsJs.polyfill();

LogUtils.initSentry();

let updateSWRef = {
  contents: prim => {}
};

updateSWRef.contents = VirtualpwaRegister.registerSW({
  onNeedRefresh: () => Toast.addMessage({
    TAG: "Info",
    id: "sw-need-refresh",
    message: <>
      {"Je k dispozici nová verze\xA0\xA0"}
      <button
        className={Styles.link.base}
        type={"button"}
        onClick={param => updateSWRef.contents()}
      >
        {"Aktualizovat"}
      </button>
    </>
  }),
  onOfflineReady: () => {
    if (!AppStorage.hasSeenOfflineModeReady()) {
      return Toast.addMessage({
        TAG: "Info",
        id: "sw-offline-ready",
        message: "Po přihlášení se stránka obejde i bez internetu.",
        onClose: () => AppStorage.markSeenOfflineModeReady()
      });
    }
  }
});

Client.createRoot(Stdlib_Option.getOrThrow(Primitive_option.fromNullable(document.querySelector("#root")), undefined)).render(<React.StrictMode>
  <Reactfire$1.FirebaseAppProvider
    firebaseConfig={Primitive_option.some(Reactfire.firebaseConfig)}
    suspense={true}
  >
    <ReactIntl.IntlProvider
      locale={"cs"}
      onError={err => ((process.env.NODE_ENV === 'development' && err.code !== "MISSING_TRANSLATION" && console.error(err)))}
    >
      <App.make />
    </ReactIntl.IntlProvider>
  </Reactfire$1.FirebaseAppProvider>
</React.StrictMode>);

export {
  polyfill,
  updateSWRef,
}
/*  Not a pure module */
